import store from '@/store'

export const PROMO_DISMISSED_UNTIL_KEY = 'promo_campaign_dismissed_until'
export const DISMISS_MS = 24 * 60 * 60 * 1000

export const defaultPromoCode = 'SATOSHI2026'

export function getPromoDismissedUntil() {
  const raw = localStorage.getItem(PROMO_DISMISSED_UNTIL_KEY)
  return raw ? Number(raw) : null
}

export function isPromoDismissed() {
  const until = getPromoDismissedUntil()
  return until != null && Date.now() < until
}

export function setPromoDismissed() {
  localStorage.setItem(
    PROMO_DISMISSED_UNTIL_KEY,
    String(Date.now() + DISMISS_MS),
  )
}

export function shouldShowPromoModal({ eligible, hasActiveSubscription }) {
  if (!eligible) return false
  if (hasActiveSubscription) return false
  if (isPromoDismissed()) return false
  if (!store.getters['payment/isFreePlan']) return false
  return true
}
